// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, layoutContainer, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

interface BannerPageLayoutSharedStyles {
    wrapper?: InjectableCss;
    bannerSection?: InjectableCss;
    bannerWrapper?: InjectableCss;
    infoSection?: InjectableCss;
    mainSection?: InjectableCss;
}

const bannerPageLayoutSharedStyles: BannerPageLayoutSharedStyles = {
    bannerSection: {
        css: css`
            ${xScreen("gt", "sm")} {
                ${({ gap, backgroundImage, isFullContainer, isCmsEditing }: any) =>
                    css`
                        margin-bottom: ${gap || 8}px;

                        ${!isCmsEditing &&
                        backgroundImage &&
                        isFullContainer &&
                        css`
                            background-image: url(${backgroundImage});
                            background-repeat: no-repeat;
                            background-position-x: right;
                        `}
                    `};
            }
        `,
    },
    bannerWrapper: {
        css: css`
            position: relative;

            ${xScreen("gt", "sm")} {
                ${({ backgroundImage, isFullContainer, isCmsEditing }: any) =>
                    css`
                        ${backgroundImage &&
                        !isFullContainer &&
                        css`
                            background-image: url(${backgroundImage});
                            background-repeat: no-repeat;
                            background-position-x: right;
                            min-height: 140px;
                        `}
                        ${!isCmsEditing &&
                        css`
                            display: flex;
                        `}
                    `};
            }
            ${layoutContainer}
        `,
    },

    infoSection: {
        css: css`
            height: 100%;
            padding-top: 20px;
            nav[data-test-selector="pageBreadcrumbs"] {
                margin-bottom: 16px;
            }

            ${xScreen("gt", "sm")} {
                padding-left: 20px;
                padding-right: 20px;
                margin-left: -20px;
                padding-bottom: 30px;
                height: inherit;
                width: 100%;
                max-width: 46%;

                h2,
                h1 {
                    margin-bottom: 0;
                }
            }

            ${xScreen("lte", "md")} {
                max-width: 70%;
            }

            ${xScreen("lte", "sm")} {
                max-width: 100%;
            }

            ${({ backgroundImage }: any) =>
                backgroundImage &&
                css`
                    ${xScreen("gt", "sm")} {
                        box-shadow: -100vmax 0 0 100vmax ${color("common.ui12")};
                        clip-path: inset(0 -100vmax);
                        background: linear-gradient(
                            0.25turn,
                            ${color("common.ui12")},
                            80%,
                            ${color("common.ui12", 0.8)},
                            95%,
                            ${color("common.ui12", 0)}
                        );
                    }
                `};
        `,
    },
    mainSection: {
        css: css`
            width: 100%;
            ${layoutContainer}
        `,
    },
};

export default bannerPageLayoutSharedStyles;
